import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=52fb3e96"
import script from "./EditGroup.vue?vue&type=script&lang=js"
export * from "./EditGroup.vue?vue&type=script&lang=js"
import style0 from "./EditGroup.vue?vue&type=style&index=0&id=52fb3e96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports